import { PropTypes } from 'prop-types'

import { HStack, VStack, Stack, Text } from '@chakra-ui/react'

import { CoinLabel } from './CoinLabel'
import { SecondaryButton } from '@!/components/Button'

export const CoinBox = (props) => {
  const { coinCount, onClose } = props

  return (
    <Stack padding={'15px 0 24px'}>
      <VStack>
        <HStack>
          <Text fontSize={'1em'} fontWeight={600}>
            残コイン数
          </Text>
          <CoinLabel coinCount={coinCount} />
        </HStack>
        <HStack spacing={3} w="100%" h="37px">
          <SecondaryButton as="a" href="/user/payment#/monthly_course" onClick={onClose} height="100%">
            月額登録
          </SecondaryButton>

          <SecondaryButton as="a" href="/user/payment#/coin" onClick={onClose} height="100%">
            コイン購入
          </SecondaryButton>
        </HStack>
      </VStack>
    </Stack>
  )
}

CoinBox.propType = {
  coinCount: PropTypes.number.isRequired,
}
